import { useMutation, useQuery } from '@tanstack/react-query';

import { forgotPasswordRtkKey, getRoleListRtkKey, getPhoneCodeRtkKey, getAccessLevelListRtkKey, loginRtkKey, signupRtkKey, verifyOtpRtkKey, resetPasswordRtkKey, changePasswordRtkKey, resendOtpRtkKey, updateDetailsRtkKey, getProfileRtkKey, getPermissionListRtkKey, getUserListRtkKey, getUserDetailRtkKey, deleteUserRtkKey, createUserRtkKey, updateUserRtkKey, getRoleManagementListRtkKey, createRoleRtkKey, updateRoleRtkKey, deleteRoleRtkKey, getPermissionManagementListRtkKey, createPermissionRtkKey, updatePermissionRtkKey, deletePermissionRtkKey, getTemplateListRtkKey, createTemplateRtkKey, getTemplateDetailRtkKey, deleteTemplateRtkKey, downloadTemplateRtkKey, getTemplateForUserRtkKey, uploadTemplateRtkKey, getChartListRtkKey, getChartDetailsRtkKey, getChartDataRtkKey, getChartDataByKpiRtkKey, getIndicatorListRtkKey, deleteTemplateDataRtkKey, getActivityLogRtkKey, getDataHouseRtkKey, getDataHouseDetailsRtkKey, deleteDataHouseRtkKey } from '@/utils/rtkKeys';

import { getRoleListApi, getPhoneCodeApi, loginApi, sendOtpApi, signupApi, verifyOtpApi, resetPasswordApi, changePasswordApi, resendOtpApi, updateDetailsApi, getProfileApi, getAccessLevelListApi, getPermissionListApi, getUserListApi, getUserDetailApi, deleteUserApi, createUserApi, updateUserApi, getRoleManagementListApi, createRoleApi, updateRoleApi, deleteRoleApi, getPermissionManagementListApi, createPermissionApi, updatePermissionApi, deletePermissionApi, getTemplateListApi, createTemplateApi, getTemplateDetailApi, deleteTemplateApi, downloadTemplateApi, getTemplateForUserApi, uploadTemplateApi, getChartListApi, getChartDetailsApi, getChartDataApi, getChartDataByKpiApi, getIndicatorListApi, deleteTemplateDataApi, getActivityLogApi, getDataHouseApi, getDataHouseDetailsApi, deleteDataHouseApi } from './apiService';

export function useLoginMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [loginRtkKey],
    mutationFn: async (payload: any) => {
      const response = await loginApi(payload);
      return response;
    },
  });
}

export function useSendOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [forgotPasswordRtkKey],
    mutationFn: async (payload: any) => {
      const response = await sendOtpApi(payload);
      return response;
    },
  });
}

export function useResetPasswordMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [resetPasswordRtkKey],
    mutationFn: async (data: any) => {
      const response = await resetPasswordApi(data);
      return response;
    },
  });
}

export function useChangePasswordMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [changePasswordRtkKey],
    mutationFn: async (data: any) => {
      const response = await changePasswordApi(data);
      return response;
    },
  });
}

export function useUpdateDetailsMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [updateDetailsRtkKey],
    mutationFn: async (data: any) => {
      const response = await updateDetailsApi(data);
      return response;
    },
  });
}

export function useCreateUserMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createUserRtkKey],
    mutationFn: async (data: any) => {
      const response = await createUserApi(data);
      return response;
    },
  });
}



export function useGetAccessLevelListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getAccessLevelListRtkKey],
    queryFn: async () => {
      const response = await getAccessLevelListApi();
      return response;
    },
  });
}

export function useGetPermissionListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getPermissionListRtkKey],
    queryFn: async () => {
      const response = await getPermissionListApi();
      return response;
    },
  });
}

export function useGetUserListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getUserListRtkKey, params],
    queryFn: async () => {
      const response = await getUserListApi(params);
      return response;
    },
    staleTime: 300,
    gcTime: 300,
    ...options,
  });
}

export function useGetUserDetailQuery(userId: string, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getUserDetailRtkKey, userId],
    queryFn: async () => {
      const response = await getUserDetailApi(userId);
      return response;
    },
    enabled: !!userId,
    ...options,
  });
}

export function useGetProfileQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getProfileRtkKey],
    queryFn: async () => {
      const response = await getProfileApi();
      return response;
    },
    enabled: false,
  });
}

export function useDeleteUserMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deleteUserRtkKey],
    mutationFn: async (id: any) => {
      const response = await deleteUserApi(id);
      return response;
    },
  });
}




export function useUpdateUserMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [updateUserRtkKey],
    mutationFn: async (data: any) => {
      const response = await updateUserApi(data?.id, data);
      return response;
    },
  });
}


export function useGetTemplateForUserQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getTemplateForUserRtkKey],
    queryFn: async () => {
      const response = await getTemplateForUserApi();
      return response;
    },
  });
}

export function useUploadTemplateMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [uploadTemplateRtkKey],
    mutationFn: async ({ templateId, file }: { templateId: string; file: File }) => {
      const response = await uploadTemplateApi(templateId, file);
      return response;
    },
  });
}

export function useGetChartListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getChartListRtkKey],
    queryFn: async () => {
      const response = await getChartListApi();
      return response;
    },
  });
}


export function useGetChartDetailsQuery(id: string) {
  return useQuery<any, Error, any>({
    queryKey: [getChartDetailsRtkKey, id],
    queryFn: async () => {
      const response = await getChartDetailsApi(id);
      return response;
    },
    // enabled: !!id,
  });
}


export function useGetChartDataQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getChartDataRtkKey],
    queryFn: async () => {
      const response = await getChartDataApi();
      return response;
    },
  });
}

  export function useGetChartDataByKpiQuery(kpiId: string, session: string, year: string, baselineYearStart: string, baselineYearEnd: string, targetYearStart: string, targetYearEnd: string) {
  return useQuery<any, Error, any>({
    queryKey: [getChartDataByKpiRtkKey, kpiId, session, year, baselineYearStart, baselineYearEnd, targetYearStart, targetYearEnd],
    queryFn: async () => {
      const response = await getChartDataByKpiApi(kpiId, session, year, baselineYearStart, baselineYearEnd, targetYearStart, targetYearEnd);
      return response;
    },
    staleTime: 0,
    gcTime: 0,
    enabled: !!kpiId && !!session && !!year,
  });
}



export function useGetIndicatorListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getIndicatorListRtkKey],
    queryFn: async () => {
      const response = await getIndicatorListApi();
      return response;
    },
  });
}










export function useSignupMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [signupRtkKey],
    mutationFn: async (payload: any) => {
      const response = await signupApi(payload);
      return response;
    },
  });
}

export function useVerifyOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [verifyOtpRtkKey],
    mutationFn: async (payload: any) => {
      const response = await verifyOtpApi(payload);
      return response;
    },
  });
}

export function useGetPhoneCodeQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getPhoneCodeRtkKey],
    queryFn: async () => {
      const response = await getPhoneCodeApi();
      return response;
    },
  });
}

export function useGetRoleListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getRoleListRtkKey],
    queryFn: async () => {
      const response = await getRoleListApi();
      return response;
    },
  });
}

export function useResendOtpMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [resendOtpRtkKey],
    mutationFn: async (data: any) => {
      const response = await resendOtpApi(data);
      return response;
    },
  });
}


export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  return !!token;
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const clearAuth = (): void => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/login';
};

// Role Management Services
export function useGetRoleManagementListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getRoleManagementListRtkKey],
    queryFn: async () => {
      const response = await getRoleManagementListApi();
      return response;
    },
  });
}

export function useCreateRoleMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createRoleRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createRoleApi(payload);
      return response;
    },
  });
}

export function useUpdateRoleMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [updateRoleRtkKey],
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const response = await updateRoleApi(id, data);
      return response;
    },
  });
}

export function useDeleteRoleMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deleteRoleRtkKey],
    mutationFn: async (id: string) => {
      const response = await deleteRoleApi(id);
      return response;
    },
  });
}

// Permission Management Services
export function useGetPermissionManagementListQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getPermissionManagementListRtkKey],
    queryFn: async () => {
      const response = await getPermissionManagementListApi();
      return response;
    },
  });
}

export function useCreatePermissionMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createPermissionRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createPermissionApi(payload);
      return response;
    },
  });
}

export function useUpdatePermissionMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [updatePermissionRtkKey],
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const response = await updatePermissionApi(id, data);
      return response;
    },
  });
}

export function useDeletePermissionMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deletePermissionRtkKey],
    mutationFn: async (id: string) => {
      const response = await deletePermissionApi(id);
      return response;
    },
  });
}

// Template Management Services
export function useGetTemplateListQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getTemplateListRtkKey, params],
    queryFn: async () => {
      const response = await getTemplateListApi(params);
      return response;
    },
    ...options,
  });
}

export function useCreateTemplateMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [createTemplateRtkKey],
    mutationFn: async (payload: any) => {
      const response = await createTemplateApi(payload);
      return response;
    },
  });
}

export function useGetTemplateDetailQuery(templateId: string, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getTemplateDetailRtkKey, templateId],
    queryFn: async () => {
      const response = await getTemplateDetailApi(templateId);
      return response;
    },
    enabled: !!templateId,
    ...options,
  });
}

export function useDeleteTemplateMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deleteTemplateRtkKey],
    mutationFn: async (id: string) => {
      const response = await deleteTemplateApi(id);
      return response;
    },
  });
}

export function useDownloadTemplateMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [downloadTemplateRtkKey],
    mutationFn: async ({ id, formatType }: { id: string; formatType: string }) => {
      const response = await downloadTemplateApi(id, formatType);
      return response;
    },
  });
} 


export function useDeleteTemplateDataMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deleteTemplateDataRtkKey],
    mutationFn: async (payload: any) => {
      const response = await deleteTemplateDataApi(payload);
      return response;
    },
  });
}


export function useGetActivityLogQuery(params: any = {}, options: any = {}) {
  return useQuery<any, Error, any>({
    queryKey: [getActivityLogRtkKey, params],
    queryFn: async () => {
      const response = await getActivityLogApi(params);
      return response;
    },
    ...options,
  });
}


export function useGetDataHouseMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [getDataHouseRtkKey],
    mutationFn: async (payload: any) => {
      const response = await getDataHouseApi(payload);
      return response;
    },
  });
}

export function useGetDataHouseDetailsQuery() {
  return useQuery<any, Error, any>({
    queryKey: [getDataHouseDetailsRtkKey],
    queryFn: async () => {
      const response = await getDataHouseDetailsApi();
      return response;
    },
  });
}

export function useDeleteDataHouseMutation() {
  return useMutation<any, Error, any>({
    mutationKey: [deleteDataHouseRtkKey],
    mutationFn: async (payload: any) => {
      const response = await deleteDataHouseApi(payload);
      return response;
    },
  });
}